import React, { useEffect, useState } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NavMenu } from '../../navMenu';
import UserDetails from './userDetails'
import Accounts from '../contact/relatedAccounts'
import Studies from '../contact/relatedStudies'

import { Route, Switch, Link, BrowserRouter as Router, Redirect } from 'react-router-dom';
const menus = [
  { to: "/account/users/view", text: "Contact Details" },
  { to: "/account/users/view/accounts", text: "Related Accounts" },
  { to: "/account/users/view/studies", text: "Related Studies" },
  // { to: "/account/users/audittrail", text: "Audit Trail" },
]
const ContactDetailsHome = (props) => {

  return (
    <>
      <div className="d-flex mb-3 justify-content-end">
        <h1 className="mr-auto primary-header">{props.formValues.firstName} {props.formValues.lastName}</h1>
      </div>

      <NavMenu menus={menus} />
      <div className="mt-4">
        <Route path="/account/users/view/Accounts" component={Accounts} />
        <Route path="/account/users/view/studies" component={Studies} />
        <Route exact path="/account/users/view" component={UserDetails} />
        {/* <Route path="/account/contact/audittrail" component={Audittrail} /> */}
      </div>

    </>
  );
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactDetailsHome));
